var __WEBPACK_NAMESPACE_OBJECT__ = require("core-js/modules/es.date.to-primitive.js");